import { render, staticRenderFns } from "./LeadStatusNote.vue?vue&type=template&id=2ced1e17"
import script from "./LeadStatusNote.vue?vue&type=script&lang=js"
export * from "./LeadStatusNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports